module.exports = __webpack_public_path__ + "img/icon_aside_word2_active.99924f37.svg";